import { render, staticRenderFns } from "./tOptions.vue?vue&type=template&id=936e279a&scoped=true&"
import script from "./tOptions.vue?vue&type=script&lang=js&"
export * from "./tOptions.vue?vue&type=script&lang=js&"
import style0 from "./tOptions.vue?vue&type=style&index=0&id=936e279a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936e279a",
  null
  
)

export default component.exports